import React, { useState } from "react";
import { ChevronRight16Regular, ArrowRightRegular } from "@fluentui/react-icons";
import "./HomeSection.scss";
import ServicesSection from "./ServicesSection";

type TabKey = "overview" | "software";

interface ProductItem {
  id: string;
  title: string;
  iconSrc: string;
  subtitle?: string;
  linkText?: string;
  labels?: string;
  pageLink?: string;
  badge?: string;
  accentColor?: string;
}

// ── Icons (unchanged) ──────────────────────────────────────────
const SMS = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZmlsbD0iIzA3NjZCNiIgZD0iTTAgMTJhNiA2IDAgMCAxIDYtNmg5YTMgMyAwIDEgMSAwIDZIOWEzIDMgMCAxIDAgMCA2aDlhNiA2IDAgMCAxLTYgNkg2YTYgNiAwIDAgMS02LTZ2LTZaIj48L3BhdGg+PHBhdGggZmlsbD0iIzYzQ0ZGMyIgZD0iTTI0IDEyYTYgNiAwIDAgMS02IDZIOWEzIDMgMCAxIDEgMC02aDZhMyAzIDAgMSAwIDAtNkg2YTYgNiAwIDAgMSA2LTZoNmE2IDYgMCAwIDEgNiA2djZaIj48L3BhdGg+PC9zdmc+";

const HMS_ICON = "data:image/svg+xml;charset=utf-8;base64,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";

const CMAIL_PLACEHOLDER = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none'%3E%3Crect width='24' height='24' rx='4' fill='%230078d4'/%3E%3Cpath d='M4 8l8 5 8-5' stroke='white' stroke-width='1.5' stroke-linecap='round'/%3E%3Crect x='4' y='7' width='16' height='11' rx='1.5' stroke='white' stroke-width='1.5' fill='none'/%3E%3C/svg%3E";
const CRM_PLACEHOLDER   = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none'%3E%3Crect width='24' height='24' rx='4' fill='%23107c10'/%3E%3Ccircle cx='9' cy='9' r='3' stroke='white' stroke-width='1.5' fill='none'/%3E%3Cpath d='M3 19c0-3.314 2.686-6 6-6s6 2.686 6 6' stroke='white' stroke-width='1.5' stroke-linecap='round' fill='none'/%3E%3Ccircle cx='17' cy='8' r='2.5' stroke='white' stroke-width='1.5' fill='none'/%3E%3Cpath d='M21 16c0-2.21-1.79-4-4-4' stroke='white' stroke-width='1.5' stroke-linecap='round' fill='none'/%3E%3C/svg%3E";
const ACCOUNTING_PLACEHOLDER = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none'%3E%3Crect width='24' height='24' rx='4' fill='%23d13438'/%3E%3Cpath d='M6 12h12M6 8h8M6 16h6' stroke='white' stroke-width='1.5' stroke-linecap='round'/%3E%3C/svg%3E";
const CHANNEL_PLACEHOLDER = "data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none'%3E%3Crect width='24' height='24' rx='4' fill='%238764b8'/%3E%3Cpath d='M4 6h16v9a2 2 0 01-2 2H6a2 2 0 01-2-2V6z' stroke='white' stroke-width='1.5' fill='none'/%3E%3Cpath d='M8 18l2 3M16 18l-2 3' stroke='white' stroke-width='1.5' stroke-linecap='round'/%3E%3C/svg%3E";

const itemsByTab: Record<TabKey, ProductItem[]> = {
  overview: [
    {
      id: "HMS",
      title: "Hospitality Management System",
      iconSrc: HMS_ICON,
      subtitle: "AI-powered operations and guest experience platform for modern hospitality businesses.",
      pageLink: "/hospitality-&-pms",
      linkText: "Discover HMS",
      badge: "AI-powered",
      accentColor: "#22c55e",
    },
    {
      id: "Email",
      title: "Email API",
      iconSrc: CMAIL_PLACEHOLDER,
      subtitle: "Developer-first email infrastructure. Transform communications into measurable revenue.",
      pageLink: "/email-&-calendars",
      linkText: "Explore  Email & Calender Services",
      accentColor: "#0078d4",
    },
    {
      id: "CRM-ERP",
      title: "CRM & ERP Solutions",
      iconSrc: CRM_PLACEHOLDER,
      subtitle: "Integrated CRM and ERP to optimise customer relationships and business processes.",
      pageLink: "/crm",
      linkText: "Learn about CRM & ERP",
      accentColor: "#107c10",
    },
    {
      id: "Accounting",
      title: "Accounting Software",
      iconSrc: ACCOUNTING_PLACEHOLDER,
      subtitle: "Streamlined bookkeeping, invoicing, and financial reporting for businesses of all sizes.",
      pageLink: "/accounting-software",
      linkText: "Discover Accounting",
      accentColor: "#d13438",
    },
  ],
  software: [
    {
      id: "Channels",
      title: "Cilpron Channels",
      iconSrc: CHANNEL_PLACEHOLDER,
      subtitle: "Unified messaging, video, and file sharing. One platform for your entire team.",
      pageLink: "/channels",
      linkText: "Explore Channels",
      badge: "New",
      accentColor: "#8764b8",
    },
    {
      id: "SMSAPI",
      title: "SMS API",
      iconSrc: SMS,
      subtitle: "Enterprise-grade SMS at scale. Engage customers and drive growth with integrated messaging.",
      pageLink: "#",
      linkText: "Learn about SMS API",
      accentColor: "#0766b6",
    },
  ],
};

const TABS: { key: TabKey; label: string }[] = [
  { key: "overview", label: "Overview" },
  { key: "software",  label: "Software" },
];

// ── ProductCard ────────────────────────────────────────────────
const ProductCard: React.FC<{ item: ProductItem }> = ({ item }) => (
  <article className="nx-card" aria-label={item.title}>
    <div className="nx-card__accent" style={{ background: item.accentColor ?? "#f97316" }} />
    <div className="nx-card__inner">
      <div className="nx-card__header">
        <div className="nx-card__icon-wrap">
          <img src={item.iconSrc} alt="" aria-hidden="true" className="nx-card__icon" />
        </div>
        {item.badge && <span className="nx-badge">{item.badge}</span>}
      </div>

      <div className="nx-card__body">
        <h3 className="nx-card__title">{item.title}</h3>
        {item.subtitle && <p className="nx-card__subtitle">{item.subtitle}</p>}
      </div>

      {item.linkText && item.pageLink && (
        <a href={item.pageLink} className="nx-card__cta" aria-label={item.labels ?? item.linkText}>
          <span>{item.linkText}</span>
          <ChevronRight16Regular aria-hidden="true" />
        </a>
      )}
    </div>
  </article>
);

// ── HomeSection ────────────────────────────────────────────────
const HomeSection: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabKey>("overview");
  const items = itemsByTab[activeTab];

  return (
    <>
      <section className="nx-section" aria-labelledby="nx-title">

        {/* ── Transition fade from dark hero above ── */}
        <div className="nx-section__fade" aria-hidden />

        <div className="nx-wrapper">

          {/* ── Header ── */}
          <header className="nx-header">
            <div className="nx-header__left">
              <span className="nx-eyebrow">CILPRON Nexora</span>
              <h2 className="nx-title" id="nx-title">
                One platform.<br />
                <span className="nx-title--accent">Every tool your business needs.</span>
              </h2>
            </div>
            <div className="nx-header__right">
              <p className="nx-subtitle">
                From hospitality management to developer APIs — CILPRON brings your
                operations, communications, and customer data into a single connected platform.
              </p>
              <a href="auth/signup" className="nx-all-link">
                Contact Supports <ArrowRightRegular />
              </a>
            </div>
          </header>

          {/* ── Tabs ── */}
          <div className="nx-tabs" role="tablist" aria-label="Product categories">
            {TABS.map((tab) => (
              <button
                key={tab.key}
                role="tab"
                id={`nx-tab-${tab.key}`}
                aria-selected={activeTab === tab.key}
                aria-controls={`nx-panel-${tab.key}`}
                className={`nx-tab${activeTab === tab.key ? " nx-tab--active" : ""}`}
                onClick={() => setActiveTab(tab.key)}
              >
                {tab.label}
              </button>
            ))}
          </div>

          {/* ── Cards ── */}
          <div
            id={`nx-panel-${activeTab}`}
            role="tabpanel"
            aria-labelledby={`nx-tab-${activeTab}`}
            className="nx-grid"
          >
            {items.map((item) => (
              <ProductCard key={item.id} item={item} />
            ))}
          </div>
        </div>
      </section>

      <ServicesSection />
    </>
  );
};

export default HomeSection;